import { render, staticRenderFns } from "./quoted-shipment.vue?vue&type=template&id=546bc811&scoped=true&"
import script from "./quoted-shipment.vue?vue&type=script&lang=js&"
export * from "./quoted-shipment.vue?vue&type=script&lang=js&"
import style0 from "./quoted-shipment.vue?vue&type=style&index=0&id=546bc811&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546bc811",
  null
  
)

export default component.exports